import React from "react"
import { TextField, Dialog, FlatButton, Toggle, SelectField, MenuItem } from "material-ui"
import UserStore from "../../../stores/UserStore"
import AccountStore from "../../../stores/AccountStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import ChooseHierarchyChip from "../../../components/hierarchy/choose_hierarchy/ChooseHierarchyChip"
import PayrollSelection from "../../../components/payroll/PayrollSelection"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { IUserDocument, IJobDocument, IJobPhase, IHierarchyItem, IUIUser, ESuepervisorJobExplicitTypes, ELanguage } from "../../../models"
import * as userActions from "../../../actions/UserActions"
import * as userHelper from "../../../helpers/userHelper"
import * as utils from "../../../helpers/utils"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import * as api from "../../../api"
import _ from "lodash"
import MultiSupervisorChips from "../../../components/supervisor/MultiSupervisorChips"
import ChooseHierarchyJobPhaseChipForPunch from "../../../components/hierarchy/choose_hierarchy/ChooseHierarchyJobPhaseChipForPunch"
import AccountUserOrganizationHierarchyAndUserRole from "../../../components/user/AccountUserOrganizationHierarchyAndUserRole"
import * as permissionHelper from "../../../helpers/permissionHelper"
import { grey700 } from "material-ui/styles/colors"
import JobsChip from "../../../components/job/JobsChip"
import EmpNewPositions_DefaultPositionSelector from "../../../components/position/employee_new_positions/EmpNewPositions_DefaultPositionSelector"
import LanguageSelector from "../../../components/language/LanguageSelector"
import PasswordField from "../../../components/common/PasswordField"
import { checkJobFieldAvailable } from "../../..//helpers/jobHelper"
import { checkPhaseFieldAvailable } from "../../../helpers/punchHelper"

interface IProps {
	editUser: IUserDocument
	handleAdd(user: IUserDocument, closeDialog: boolean): Promise<any>
	handleUpdate(user: IUserDocument): void
	close(): void
}
interface IState {
	firstName: string
	firstNameErrorText?: string
	lastName: string
	lastNameErrorText?: string
	email: string
	emailErrorText?: string
	password: string
	passwordErrorText?: string
	passwordVerified?: boolean
	passwordConfirmation: string
	passwordConfirmationErrorText?: string
	externalId: string
	externalIdErrorText?: string
	owner: boolean
	jobExplicityTypes: ESuepervisorJobExplicitTypes
	explicitJobs: IJobDocument[]
	errorExplicitJobs: string
	defaultHierarchyItemId: string
	defaultPunchHierarchyId: string
	errorDefaultPunchHierarchyId?: string
	saveClicked?: boolean
	isEmployee: boolean
	clockPin: string
	clockPinErrorText: string
	selectedSupervisorIds: string[]
	errorSupervisor: string
	isSaving: boolean
	defaultPunchJob: IJobDocument
	defaultPunchPhase: IJobPhase
	scheduleRanking: number
	fullTime: boolean
	agency: boolean
	language: ELanguage
}

export default class AddAccountUserDialog extends React.Component<IProps, IState> {
	private AccountUserOrganizationHierarchyAndUserRole
	private ChooseHierarchyJobPhaseChipForPunch
	private EmpNewPositions_DefaultPositionSelector
	private globalFilterLevelId = HierarchySettingsStore.getGlobalLevelItemFilterId() ? HierarchySettingsStore.getGlobalLevelItemFilterId() : null
	private defaultSelectedSupervisorIds = AccountStore.getSupervisorDirectReportEnabled() ?
		!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.CanAddNonDirectReportEmployees) ?
			[AuthenticationStore.getLoggedInUser().Id] :
			[] :
		[]
	constructor(props: IProps) {
		super(props)
		this.state = {
			firstName: props.editUser ? props.editUser.FirstName : "",
			lastName: props.editUser ? props.editUser.LastName : "",
			email: props.editUser ? props.editUser.Email : "",
			password: "",
			passwordConfirmation: "",
			externalId: props.editUser ? props.editUser.ExternalId : "",
			owner: props.editUser && props.editUser.Owner ? true : false,
			jobExplicityTypes: props.editUser ? props.editUser.JobExplicitTypes : ESuepervisorJobExplicitTypes.All,
			explicitJobs: [],
			errorExplicitJobs: null,
			defaultHierarchyItemId: props.editUser ? props.editUser.DefaultHierarchyItemId : this.globalFilterLevelId,
			defaultPunchHierarchyId: props.editUser ? props.editUser.DefaultPunchHierarchyId : this.globalFilterLevelId,
			isEmployee: props.editUser ? props.editUser.IsEmployee : false,
			clockPin: props.editUser ? props.editUser.ClockPin : "",
			clockPinErrorText: "",
			selectedSupervisorIds: props.editUser && props.editUser.SupervisorIds ? props.editUser.SupervisorIds : this.defaultSelectedSupervisorIds,
			errorSupervisor: "",
			isSaving: false,
			defaultPunchJob: null,
			defaultPunchPhase: null,
			scheduleRanking: props.editUser ? props.editUser.ScheduleWeight : 0,
			fullTime: props.editUser ? props.editUser.FullTime : false,
			agency: props.editUser ? props.editUser.Agency : false,
			language: props.editUser ? props.editUser.Language : ELanguage.English
		}
		autobind(this)
	}

	componentDidMount() {
		this.getDefaultJob()
		this.props.editUser && this.props.editUser.ExplicitJobIds && this.props.editUser.ExplicitJobIds.length &&
			api.getJobsByIds(this.props.editUser.ExplicitJobIds).then(res =>
				this.setState({ explicitJobs: res.data })
			)

		UserStore.on("change", this.changeEvent)
		AccountStore.on("account_change", this.changeEvent)
	}

	componentWillUnmount() {
		UserStore.removeListener("change", this.changeEvent)
		AccountStore.removeListener("account_change", this.changeEvent)
	}

	changeEvent() {
		!this.props.editUser && this.clearData()
	}

	getDefaultJob() {
		if (this.props.editUser && this.props.editUser.DefaultJobId) {
			api.getJob(this.props.editUser.DefaultJobId).then(res => {
				const defaultPunchJob: IJobDocument = res.data
				this.setState({
					defaultPunchJob,
					defaultPunchPhase: defaultPunchJob.Phases.find(phase => phase.Id === this.props.editUser.DefaultPhaseId)
				})
			})
		}
	}

	clearData() {
		this.AccountUserOrganizationHierarchyAndUserRole.setState({
			organizationHierarchyId: this.globalFilterLevelId,
			errorOrganizationHierarchyId: "",
			isAdmin: false,
			userRoleId: null,
			errorUserRoleId: "",
		})
		this.setState({
			firstName: "",
			lastName: "",
			email: "",
			password: "",
			passwordConfirmation: "",
			externalId: "",
			owner: false,
			jobExplicityTypes: ESuepervisorJobExplicitTypes.All,
			explicitJobs: [],
			errorExplicitJobs: null,
			firstNameErrorText: "",
			lastNameErrorText: "",
			emailErrorText: "",
			passwordErrorText: "",
			passwordConfirmationErrorText: "",
			saveClicked: false,
			isEmployee: false,
			clockPin: "",
			scheduleRanking: 0,
			clockPinErrorText: "",
			defaultHierarchyItemId: this.globalFilterLevelId,
			defaultPunchHierarchyId: this.globalFilterLevelId,
			selectedSupervisorIds: this.defaultSelectedSupervisorIds,
			errorSupervisor: "",
			isSaving: false,
			defaultPunchJob: null,
			defaultPunchPhase: null,
			fullTime: false,
			agency: false,
			language: ELanguage.English
		})
	}

	detectEnter(event) {
		event.keyCode === 13 && this.handleSave()
	}

	handleSave(closeDialog = true) {
		return new Promise(resolve =>
			this.setState({ saveClicked: true, isSaving: true }, () =>
				this.checkValidate().then(result => {
					if (!result) {
						resolve(false)
					}
					else {
						const payrollSelection: any = this.refs.PayrollSelection
						const { organizationHierarchyId, userRoleId } = this.AccountUserOrganizationHierarchyAndUserRole.state
						let empUserRole = null
						if (this.state.isEmployee) {
							empUserRole = permissionHelper.getSpecificUserRole(null, AuthenticationStore.SpecialPermission.SelfService, true)
						}
						let user: IUserDocument
						if (this.props.editUser) {
							user = _.cloneDeep(this.props.editUser)
							user.FirstName = this.state.firstName
							user.LastName = this.state.lastName
							user.Email = this.state.email
							user.ExternalId = this.state.externalId
							user.Owner = this.state.owner
							user.JobExplicitTypes = this.state.jobExplicityTypes
							user.ExplicitJobIds = this.state.jobExplicityTypes === ESuepervisorJobExplicitTypes.All ? [] : this.state.explicitJobs.map(i => i.Id)
							user.PasswordUpdate = this.state.password
							user.DefaultHierarchyItemId = this.state.defaultHierarchyItemId
							user.OrganizationHierarchyId = organizationHierarchyId
							user.DefaultPunchHierarchyId = this.state.defaultPunchHierarchyId
							user.DefaultJobId = this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null
							user.DefaultJobName = this.state.defaultPunchJob ? this.state.defaultPunchJob.Name : null
							user.DefaultPhaseId = this.state.defaultPunchJob && this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Id : null
							user.DefaultPhaseName = this.state.defaultPunchJob && this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Name : null
							user.UserRoleId = userRoleId
							user.IsEmployee = this.state.isEmployee
							user.ClockPin = this.state.isEmployee ? this.state.clockPin : null
							user.DefaultPositionId = this.EmpNewPositions_DefaultPositionSelector && this.EmpNewPositions_DefaultPositionSelector.state.defaultPositionId ? this.EmpNewPositions_DefaultPositionSelector.state.defaultPositionId : null
							user.Positions = this.EmpNewPositions_DefaultPositionSelector && this.EmpNewPositions_DefaultPositionSelector.state.newEmpPositions && this.EmpNewPositions_DefaultPositionSelector.state.newEmpPositions.length > 0 ?
								this.EmpNewPositions_DefaultPositionSelector.state.newEmpPositions : []
							user.PayrollHierarchyItemId = this.state.isEmployee && AccountStore.getTimecardEnabled() ? payrollSelection.state.employeePayrollHierarchyItem.Id : null
							user.PayrollPayGroupId = this.state.isEmployee && AccountStore.getTimecardEnabled() ? payrollSelection.state.employeePayrollPayGroupId : null
							user.OTPolicyId = this.state.isEmployee && AccountStore.getEnableOTPolicy() && payrollSelection.state.otPolicyManualSet ?
								payrollSelection.state.otPolicyId :
								null
							user.SupervisorIds = this.state.isEmployee && this.state.selectedSupervisorIds.length ? this.state.selectedSupervisorIds : null
							user.UserRole = empUserRole
							user.ScheduleWeight = this.state.scheduleRanking
							user.FullTime = this.state.fullTime
							user.Agency = this.state.agency
							user.Language = this.state.language
							if (AccountStore.getExplicitAccountUserHierarchyAssignment() || AccountStore.getExplicitEmployeeHierarchyAssignment()) {
								const LinkedHierarchyIds = this.props.editUser.LinkedHierarchyIds ? this.props.editUser.LinkedHierarchyIds.slice() : []
								if (organizationHierarchyId && LinkedHierarchyIds.indexOf(organizationHierarchyId) === -1) {
									LinkedHierarchyIds.push(organizationHierarchyId)
									user.LinkedHierarchyIds = LinkedHierarchyIds
								}
							}
							this.props.handleUpdate(user)
						}
						else {
							user = {
								Id: utils.guid(),
								AccountId: AccountStore.getCurrentAccount().Id,
								FirstName: this.state.firstName,
								LastName: this.state.lastName,
								Email: this.state.email,
								ExternalId: this.state.externalId,
								Owner: this.state.owner,
								JobExplicitTypes: this.state.jobExplicityTypes,
								ExplicitJobIds: this.state.jobExplicityTypes === ESuepervisorJobExplicitTypes.All ? [] : this.state.explicitJobs.map(i => i.Id),
								PasswordUpdate: this.state.password,
								DefaultHierarchyItemId: this.state.defaultHierarchyItemId,
								OrganizationHierarchyId: organizationHierarchyId,
								DefaultPunchHierarchyId: this.state.defaultPunchHierarchyId,
								DefaultJobId: this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null,
								DefaultJobName: this.state.defaultPunchJob ? this.state.defaultPunchJob.Name : null,
								DefaultPhaseId: this.state.defaultPunchJob && this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Id : null,
								DefaultPhaseName: this.state.defaultPunchJob && this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Name : null,
								UserRole: empUserRole,
								UserRoleId: userRoleId,
								IsEmployee: this.state.isEmployee,
								LinkedHierarchyIds: AccountStore.getExplicitAccountUserHierarchyAssignment() || AccountStore.getExplicitEmployeeHierarchyAssignment() ? [organizationHierarchyId] : null,
								ClockPin: this.state.isEmployee ? this.state.clockPin : null,
								DefaultPositionId: this.EmpNewPositions_DefaultPositionSelector && this.EmpNewPositions_DefaultPositionSelector.state.defaultPositionId ? this.EmpNewPositions_DefaultPositionSelector.state.defaultPositionId : null,
								Positions: this.EmpNewPositions_DefaultPositionSelector && this.EmpNewPositions_DefaultPositionSelector.state.newEmpPositions && this.EmpNewPositions_DefaultPositionSelector.state.newEmpPositions.length > 0 ?
									this.EmpNewPositions_DefaultPositionSelector.state.newEmpPositions : [],
								PayrollHierarchyItemId: this.state.isEmployee && AccountStore.getTimecardEnabled() ? payrollSelection.state.employeePayrollHierarchyItem.Id : null,
								PayrollPayGroupId: this.state.isEmployee && AccountStore.getTimecardEnabled() ? payrollSelection.state.employeePayrollPayGroupId : null,
								OTPolicyId: this.state.isEmployee && AccountStore.getEnableOTPolicy() && payrollSelection.state.otPolicyManualSet ?
									payrollSelection.state.otPolicyId :
									null,
								SupervisorIds: this.state.isEmployee && this.state.selectedSupervisorIds.length ? this.state.selectedSupervisorIds : null,
								ScheduleWeight: this.state.isEmployee && AccountStore.getScheduleEnabled() ? this.state.scheduleRanking : null,
								Agency: this.state.agency,
								Float: false,
								PerDiem: false,
								FullTime: this.state.fullTime,
								Language: this.state.language
							}
							this.props.handleAdd(user, closeDialog).then(res => resolve(res))
						}
					}
					this.setState({ isSaving: false })
				})
			)
		)
	}

	checkValidate() {
		let returnVal = true
		if (this.AccountUserOrganizationHierarchyAndUserRole.state.errorOrganizationHierarchyId) {
			returnVal = false
		}
		if (this.AccountUserOrganizationHierarchyAndUserRole.state.errorUserRoleId) {
			returnVal = false
		}

		if (this.state.firstName.length === 0) {
			this.setState({ firstNameErrorText: strings.First_Name_cannot_be_empty })
			returnVal = false
		}
		else if (!utils.validateName(this.state.firstName)) {
			this.setState({ firstNameErrorText: strings.only_letters_hyphens_periods_and_spaces_are_allowed })
			returnVal = false
		}
		else {
			this.setState({ firstNameErrorText: "" })
		}

		if (this.state.lastName.length === 0) {
			this.setState({ lastNameErrorText: strings.Last_Name_cannot_be_empty })
			returnVal = false
		}
		else if (!utils.validateName(this.state.lastName)) {
			this.setState({ lastNameErrorText: strings.only_letters_hyphens_periods_and_spaces_are_allowed })
			returnVal = false
		}
		else {
			this.setState({ lastNameErrorText: "" })
		}

		if (utils.validateEmail(this.state.email)) {
			this.setState({ emailErrorText: "" })
		} else {
			this.setState({ emailErrorText: strings.Invalid_email_format })
			returnVal = false
		}

		//if we are editing, do not require a password. If we don't have a password set, then it won't update.
		if (!this.props.editUser && !this.state.password) {
			this.setState({ passwordErrorText: strings.Password_required })
			returnVal = false
		}
		else {
			this.setState({ passwordErrorText: "" })
			if (this.state.password && !this.state.passwordVerified) {
				returnVal = false
			}
		}

		if (this.state.password !== this.state.passwordConfirmation) {
			this.setState({ passwordConfirmationErrorText: strings.Passwords_must_match })
			returnVal = false
		} else {
			this.setState({ passwordConfirmationErrorText: "" })
		}

		if (!this.state.email) {
			this.setState({ emailErrorText: strings.Email_cannot_be_empty })
			returnVal = false
		}
		else {
			this.setState({ emailErrorText: "" })
		}

		if (this.state.jobExplicityTypes !== ESuepervisorJobExplicitTypes.All &&
			(!this.state.explicitJobs || this.state.explicitJobs.length === 0)
		) {
			this.setState({ errorExplicitJobs: strings.Please_select_a_job })
			returnVal = false
		}
		else {
			this.setState({ errorExplicitJobs: null })
		}

		if (this.state.isEmployee) {
			if (this.EmpNewPositions_DefaultPositionSelector && this.EmpNewPositions_DefaultPositionSelector.state.errorDefaultPositionId) {
				returnVal = false
			}

			if (!AccountStore.getExplicitEmployeeHierarchyAssignment()) {
				if (!userHelper.getEmployeeValidationForDefaultAndPunch(this.state.defaultHierarchyItemId, this.state.defaultPunchHierarchyId)) {
					this.setState({ errorDefaultPunchHierarchyId: strings.Default_cannot_be_outside_the_Punch_Permission_Hierarchy })
					returnVal = false
				}
				else {
					this.setState({ errorDefaultPunchHierarchyId: "" })
				}
			}
			if (this.ChooseHierarchyJobPhaseChipForPunch && this.ChooseHierarchyJobPhaseChipForPunch.state.errorHierarchyItemId) {
				returnVal = false
			}
		}

		if (AccountStore.getEnableOTPolicy()) {
			const payrollSelection: any = this.refs.PayrollSelection
			if (payrollSelection && payrollSelection.state.errorEmployeeOTPolicyId) {
				returnVal = false
			}
		}

		return new Promise(resolve =>
			Promise.all([
				this.checkEmailExist(),
				this.checkValidateExternalId(),
				this.checkValidateClockPin(),
				userHelper.checkValidateSupervisors(this.state.isEmployee, this.state.selectedSupervisorIds, this.state.defaultHierarchyItemId)
			]).then(res => {
				this.setState({ errorSupervisor: res[3] })
				if (!res[0] || !res[1] || !res[2] || res[3]) {
					returnVal = false
				}
				resolve(returnVal)
			})
		)
	}

	checkEmailExist() {
		return new Promise(resolve =>
			!this.state.email.trim() ?
				resolve(false) :
				this.props.editUser && this.props.editUser.Email === this.state.email ?
					resolve(true) :
					userActions.emailExists(this.state.email).then(res => {
						if (res.data) {
							this.setState({ emailErrorText: strings.Email_already_in_use })
						}
						resolve(!res.data)
					}))
	}

	checkValidateExternalId() {
		return new Promise(resolve => {
			if (this.state.externalId) {
				if (this.props.editUser && this.props.editUser.ExternalId === this.state.externalId) {
					this.setState({ externalIdErrorText: "" })
					resolve(true)
				}
				else {
					userActions.externalIdExists(AccountStore.getCurrentAccount().Id, this.state.externalId).then(res => {
						this.setState({ externalIdErrorText: res.data ? strings.Employee_ID_must_be_unique : "" })
						resolve(!res.data)
					})
				}
			}
			else {
				this.setState({ externalIdErrorText: this.state.isEmployee ? strings.This_field_is_required : "" })
				resolve(!this.state.isEmployee)
			}
		})
	}

	checkValidateClockPin() {
		return new Promise(resolve => {
			if (!this.state.isEmployee || !this.state.clockPin || (this.props.editUser && this.props.editUser.ClockPin === this.state.clockPin)) {
				this.setState({ clockPinErrorText: "" })
				resolve(true)
			}
			else {
				userActions.clockPinExists(AccountStore.getCurrentAccount().Id, this.state.clockPin).then(res => {
					this.setState({ clockPinErrorText: res.data ? strings.Employee_ID_must_be_unique : "" })
					resolve(!res.data)
				})
			}
		})
	}

	customeCheckAccessRight(selectedHierarchy: IHierarchyItem): boolean {
		return AccountStore.getExplicitAccountUserHierarchyAssignment() ?
			selectedHierarchy ?
				hierarchyHelper.getHierarchyDefinitionByHierarchyItemId(selectedHierarchy.Id).EnableAccountUsers :
				this.AccountUserOrganizationHierarchyAndUserRole.state.isAdmin :
			true
	}

	render() {
		const organizationHierarchyId = this.props.editUser ? this.props.editUser.OrganizationHierarchyId : this.globalFilterLevelId
		return (
			<Dialog
				open
				autoScrollBodyContent
				contentStyle={{ maxWidth: 1000, width: "85%" }}
				title={this.props.editUser ? strings.Edit_Account_User.toUpperCase() : strings.Add_Account_User.toUpperCase()}
				actions={[
					!this.props.editUser &&
					<FlatButton
						data-intercom-target={"menu-AccountUsers-Users-Btn-AddAnotherAccountUser"}
						primary
						disabled={this.state.isSaving}
						label={strings.Add_Another}
						style={{ float: "left", display: "inline-block" }}
						labelStyle={{ textDecoration: "underline" }}
						onTouchTap={() => this.handleSave(false).then(res => res && this.clearData())}
					/>,
					<FlatButton
						data-intercom-target={"menu-AccountUsers-Users-Btn-CloseAddAccountUserDialog"}
						label={strings.CANCEL}
						secondary
						onTouchTap={this.props.close}
					/>,
					<FlatButton
						data-intercom-target={"menu-AccountUsers-Users-Btn-SaveAccountUser"}
						primary
						disabled={this.state.isSaving}
						label={this.props.editUser ? strings.Update : strings.Save}
						style={{ display: "inline-block" }}
						onTouchTap={this.handleSave}
					/>
				]}
			>
				<form autoComplete="off">
					<div style={{ color: grey700, fontSize: 18 }}>{strings.User_Details}</div>
					<div style={{ width: "100%" }}>
						<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "25%", marginRight: 25 }}>
							<TextField
								data-intercom-target={"menu-AccountUsers-Users-Add-Entry-FirstName"}
								id="FirstNameForAddAccountUserDialog"
								autoFocus={true}
								floatingLabelText="First Name"
								value={this.state.firstName}
								onChange={(e) =>
									this.setState({ firstName: e.target.value }, () =>
										this.state.saveClicked && this.checkValidate()
									)
								}
								onKeyUp={this.detectEnter}
								errorText={this.state.firstNameErrorText}
								style={{ width: "100%" }}
								autoComplete="off"
								inputProps={{ autoComplete: "new-password" }}
							/>
						</div>
						<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "25%", marginRight: 25 }}>
							<TextField
								data-intercom-target={"menu-AccountUsers-Users-Add-Entry-LastName"}
								floatingLabelText="Last Name"
								value={this.state.lastName}
								onChange={e => this.setState({ lastName: e.target.value }, () => this.state.saveClicked && this.checkValidate())}
								onKeyUp={this.detectEnter}
								errorText={this.state.lastNameErrorText}
								style={{ width: "100%" }}
								autoComplete="off"
								inputProps={{ autoComplete: "new-password" }}
							/>
						</div>
						<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "25%", marginRight: 25 }}>
							<TextField
								data-intercom-target={"menu-AccountUsers-Users-Add-Entry-Email"}
								floatingLabelText="Email"
								value={this.state.email}
								onChange={e => this.setState({ email: e.target.value, emailErrorText: utils.validateEmail(e.target.value) ? "" : strings.Invalid_email_format })}
								onKeyUp={this.detectEnter}
								errorText={this.state.emailErrorText}
								style={{ width: "100%" }}
								autoComplete="off"
								inputProps={{ autoComplete: "new-password" }}
							/>
						</div>
						<div style={{ height: 60, display: "inline-block", verticalAlign: "top", width: "15%" }}>
							<TextField
								data-intercom-target={"menu-AccountUsers-Users-Add-Entry-ExternalId"}
								floatingLabelText="External Id"
								value={this.state.externalId || ""}
								onChange={e => this.setState({ externalId: e.target.value, externalIdErrorText: "" }, () => this.state.saveClicked && this.checkValidate())}
								onKeyUp={this.detectEnter}
								errorText={this.state.externalIdErrorText}
								style={{ width: "100%" }}
								autoComplete="off"
								inputProps={{ autoComplete: "new-password" }}
							/>
						</div>
					</div>
					<div style={{ display: "flex", flexWrap: "wrap", marginTop: 10 }}>
						<div style={{ verticalAlign: "top", width: "25%", marginRight: 25 }}>
							<PasswordField
								data-intercom-target={"menu-AccountUsers-Users-Add-Entry-Password"}
								password={this.state.password}
								errorPassword={this.state.passwordErrorText}
								handleChange={(password, passwordVerified) => this.setState({ password, passwordVerified }, () => this.state.saveClicked && this.checkValidate())}
								handleSave={(password, passwordVerified) => this.setState({ password, passwordVerified }, () => this.state.saveClicked && this.checkValidate())}
								autoComplete="new-password"
							/>
						</div>
						<div style={{ verticalAlign: "top", width: "25%" }}>
							<TextField
								data-intercom-target={"menu-AccountUsers-Users-Add-Entry-ConfirmPassword"}
								floatingLabelText="Password Confirmation"
								value={this.state.passwordConfirmation}
								onChange={e => this.setState({ passwordConfirmation: e.target.value }, () => this.state.saveClicked && this.checkValidate())}
								onKeyUp={this.detectEnter}
								type="password"
								errorText={this.state.passwordConfirmationErrorText}
								style={{ width: "100%" }}
								autoComplete="off"
								inputProps={{ autoComplete: "new-password" }}
							/>
						</div>
					</div>
				</form>
				<div style={{ marginTop: 50, marginBottom: 20 }}>
					<div style={{ color: grey700, fontSize: 18, marginBottom: 10 }}>{strings.User_Settings}</div>
					<AccountUserOrganizationHierarchyAndUserRole
						ref={item => this.AccountUserOrganizationHierarchyAndUserRole = item}
						organizationHierarchyId={organizationHierarchyId}
						userRoleId={this.props.editUser ? this.props.editUser.UserRoleId : null}
						nonCheckValidate={!this.state.saveClicked}
					/>
					<div style={{ display: "flex", alignItems: "center" }}>
						<div style={{ width: 260 }}>{strings.Application_Language}</div>
						<LanguageSelector
							hideLabel
							selectedLanguage={this.state.language}
							handleChange={language => this.setState({ language })}
						/>
					</div>
					{AccountStore.getJobsEnabled() &&
						<div style={{ marginBottom: 15 }}>
							<div style={{ display: "flex", alignItems: "center" }}>
								<div style={{ width: 260 }}>{checkJobFieldAvailable("singular") ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Explicit Assignment` : strings.Job_Explicit_Assignment}</div>
								<SelectField
									value={this.state.jobExplicityTypes}
									onChange={(event, index, jobExplicityTypes) => this.setState({ jobExplicityTypes, explicitJobs: [] }, () =>
										this.checkValidate()
									)}
								>
									<MenuItem value={ESuepervisorJobExplicitTypes.All} primaryText={checkJobFieldAvailable('plural') ? `All ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.All_Jobs} />
									<MenuItem value={ESuepervisorJobExplicitTypes.Include} primaryText={strings.Include_Only_Selected} />
									<MenuItem value={ESuepervisorJobExplicitTypes.Exclude} primaryText={strings.Exclude_Only_Selected} />
								</SelectField>
							</div>
							{this.state.jobExplicityTypes !== ESuepervisorJobExplicitTypes.All &&
								<JobsChip
									label={strings.Select_Jobs}
									filterHierarchyId={organizationHierarchyId}
									multiSelectable
									selectedJobs={this.state.explicitJobs}
									restrictHierarchy={false}
									error={this.state.errorExplicitJobs}
									handleSave={explicitJobs => this.setState({ explicitJobs }, () => this.checkValidate())}
								/>
							}
						</div>
					}
					<Toggle
						data-intercom-target={"menu-AccountUsers-Users-Add-Toggle-Owner"}
						toggled={this.state.owner}
						onToggle={(e, value) => this.setState({ owner: value })}
						labelPosition="left"
						label={strings.Owner}
						style={{ maxWidth: 300, marginTop: 10, marginBottom: 15 }}
						labelStyle={{ color: "inherited" }}
						disabled={!permissionHelper.isGlobalAdmin()}
					/>
					<Toggle
						data-intercom-target={"menu-AccountUsers-Users-Add-Toggle-IsEmployee"}
						toggled={this.state.isEmployee}
						onToggle={(e, value) => this.setState({ isEmployee: value }, () => this.state.saveClicked && this.checkValidate())}
						labelPosition="left"
						label={strings.Will_this_user_need_to_track_time}
						style={{ maxWidth: 300, marginTop: 10 }}
						labelStyle={{ color: "inherited" }}
					/>
				</div>
				{this.state.isEmployee &&
					<div>
						<div style={{ height: 60, verticalAlign: "top", width: "25%" }}>
							<TextField
								data-intercom-target={"menu-AccountUsers-Users-Add-Entry-ClockPin"}
								floatingLabelText={strings.Clock_PIN}
								value={this.state.clockPin}
								onChange={e => this.setState({ clockPin: e.target.value.replace(/\D/g, "") }, () => this.state.saveClicked && this.checkValidate())}
								errorText={this.state.clockPinErrorText}
								onKeyUp={this.detectEnter}
								style={{ width: "100%" }}
							/>
						</div>
						<div style={{ marginTop: 20 }}>
							<ChooseHierarchyChip
								getCustomNoAccessErrorStr={defaultHierarchyItem => userHelper.getSupervisorChooseEmployeeDefaultHierarchyItemErrorStr(defaultHierarchyItem)}
								chipLabel={strings.Punch_Permission_Hierarchy}
								hierarchyItemId={this.state.defaultHierarchyItemId}
								handleSelectHierarchy={defaultHierarchyItemId => this.setState({ defaultHierarchyItemId }, () => this.state.saveClicked && this.checkValidate())}
							/>
						</div>
						{!AccountStore.getExplicitEmployeeHierarchyAssignment() &&
							<div style={{ marginTop: 20 }}>
								<ChooseHierarchyJobPhaseChipForPunch
									ref={item => this.ChooseHierarchyJobPhaseChipForPunch = item}
									hideIcon
									ignoreNotAllowPunchSetting
									hierarchyChipLabel={strings.Default_Hierarchy}
									jobChipLabel={checkJobFieldAvailable("singular") ? `Default ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Default_Job}
									phaseChipLabel={checkPhaseFieldAvailable("singular") ? `Default ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings.Default_Phase}
									employee={{ DefaultHierarchyItemId: this.state.defaultHierarchyItemId } as IUIUser}
									punchHierarchyItemId={this.state.defaultPunchHierarchyId}
									jobId={this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null}
									phaseId={this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Id : null}
									errorHierarchyChipText={this.state.errorDefaultPunchHierarchyId}
									handleSelectHierarchyJobPhase={(hierarchyItemId, errorHierarchyItemId, job, phase) =>
										this.setState({
											defaultPunchHierarchyId: hierarchyItemId,
											defaultPunchJob: job,
											defaultPunchPhase: phase
										}, () => {
											this.state.saveClicked && this.checkValidate()
										})
									}
								/>
							</div>
						}
						{AccountStore.getTimecardEnabled() &&
							<PayrollSelection
								ref="PayrollSelection"
								employeePayrollHierarchyItemId={this.props.editUser && this.props.editUser.PayrollHierarchyItemId}
								employeeDefaultJob={this.state.defaultPunchJob}
								employeeDefaultPunchHierarchyItemId={this.state.defaultPunchHierarchyId}
								employeePayrollPayGroupId={this.props.editUser && this.props.editUser.PayrollPayGroupId}
								employeePayrollPayGroupManualSet={this.props.editUser && this.props.editUser.PayrollPayGroupManualSet}
								updateUserPayrollHierarchy={this.props.editUser && this.props.editUser.IsEmployee ? true : false}
								employeeOTPolicyId={this.props.editUser && this.props.editUser.OTPolicyId}
								employeeOTPolicyManualSet={this.props.editUser && this.props.editUser.OTPolicyId ? true : false}
								width="25%"
								userId={this.props.editUser && this.props.editUser.Id}
							/>
						}
						<div style={{ display: "flex", marginTop: 10 }}>
							{AccountStore.getSupervisorDirectReportEnabled() &&
								<div style={{ flex: 1 }}>
									<MultiSupervisorChips
										selectedSupervisorIds={this.state.selectedSupervisorIds}
										canChooseYourSelf={this.props.editUser ? this.props.editUser.Id !== AuthenticationStore.getLoggedInUser().Id : true}
										readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.CanAddNonDirectReportEmployees)}
										handleChange={selectedSupervisors => this.setState({ selectedSupervisorIds: selectedSupervisors.map(i => i.Id) }, () => this.state.saveClicked && this.checkValidate())}
										employeePermissionHierarchy={this.state.defaultHierarchyItemId}
										error={this.state.errorSupervisor}
									/>
								</div>
							}
							<div style={{ flex: 1 }}>
								<Toggle
									data-intercom-target={`Add-Employee-${strings.User_Information.split(" ").join("-")}-Toggle-Exempt`}
									label={strings.Exempt}
									onToggle={() => this.setState({ fullTime: !this.state.fullTime })}
									defaultToggled={this.state.fullTime}
									style={{ width: 250 }}
								/>
								<Toggle
									data-intercom-target={`Add-Employees-${strings.User_Information.split(" ").join("-")}-Toggle-Agency`}
									label={strings.User_Agency}
									onToggle={() => this.setState({ agency: !this.state.agency })}
									defaultToggled={this.state.agency}
									style={{ width: 250 }}
								/>
							</div>
						</div>
						{AccountStore.getScheduleEnabled() &&
							permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewAccountSchedule) &&
							<TextField
								data-intercom-target={"menu-AccountUsers-Users-Add-Entry-ScheduleRanking"}
								floatingLabelText={strings.Schedule_Ranking}
								value={this.state.scheduleRanking}
								onChange={e => utils.validateInteger(e.target.value) && this.setState({ scheduleRanking: Number(e.target.value) })}
							/>
						}
						<EmpNewPositions_DefaultPositionSelector
							ref={item => this.EmpNewPositions_DefaultPositionSelector = item}
							saveClicked={this.state.saveClicked}
							defaultPositionId={this.props.editUser ? this.props.editUser.DefaultPositionId : null}
							positions={this.props.editUser && this.props.editUser.Positions ? this.props.editUser.Positions : []}
							defaultPunchHierarchyId={this.state.defaultPunchHierarchyId}
							defaultPunchJobId={this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null}
							defaultPunchPhaseId={this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Id : null}
							userPayrollData={{
								Id: this.props.editUser ? this.props.editUser.Id : null,
								PayrollHierarchyItemId: this.refs.PayrollSelection && (this.refs.PayrollSelection as any).state.employeePayrollHierarchyItem.Id,
								DefaultPunchHierarchyId: this.state.defaultPunchHierarchyId,
								DefaultJobId: this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null,
								PayrollPayGroupId: this.refs.PayrollSelection && (this.refs.PayrollSelection as any).state.employeePayrollPayGroupId
							}}
							defaultJob={this.state.defaultPunchJob}
						/>
					</div>
				}
			</Dialog>
		)
	}
}